const ITEMS = ["Innovation", "Business", "Technology", "IND RIL", "Urgent Sell & Buy", "BOSS AI OS"];

export const Marquee = () => (
  <section className="relative py-10 border-y border-[#d4af37]/15 overflow-hidden bg-[#06070b]" aria-label="Brand marquee" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {ITEMS.concat(ITEMS).map((t, i) => (
            <span key={`${k}-${i}`} className="flex items-center">
              <span className={`px-8 whitespace-nowrap text-5xl sm:text-7xl ${i % 2 ? "font-serif-i text-[#e9d58e]" : "font-display font-bold text-white/90 uppercase tracking-tight"}`}>
                {t}
              </span>
              <svg viewBox="0 0 20 20" className="w-5 h-5 text-[#00f0ff]" aria-hidden="true"><path d="M10 0 L12 8 L20 10 L12 12 L10 20 L8 12 L0 10 L8 8 Z" fill="currentColor" /></svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
